import { Category } from './category'
import { SimpleDictionary } from './dictionary'
import { Privacy } from './privacy'
import { Tag } from './tag'
import { Owner } from './user'

export class Word {
  id: number
  owner: Owner
  category: Category | null
  tags: Tag[]
  dictionaries: SimpleDictionary[]
  created_at: string
  last_update: string
  likes: number
  is_liked: boolean
  bookmarks: number
  is_bookmarked: boolean
  time_since_creation: string
  language: string
  word: string
  slug: string | null
  article: string | null
  pos: string | null
  example: string | null
  definition: string | null
  privacy: Privacy
  is_mine?: boolean
}
